import React, { useState, useEffect } from 'react';
import { Box, Grid, Button, useTheme } from '@mui/material';

import HotelDescription from './HotelDescription';
import PricesHotelDetail from './PricesHotelDetail';
import HotelHead from './HotelHead';
import HotelImageCarousel from './HotelImageCarousel';

import RoomIcon from '@mui/icons-material/Room';
import ShareIcon from '@mui/icons-material/Share';

import defaultImage from '@shared/assets/slides-noImg/no-hotel1.png';

const BoxHotelDetails = ({
  hotelDetailResult,
  handleShowModal,
  search,
  goToTable,
  handleOpenShareModal,
}) => {
  const [hotelImages, setHotelImages] = useState([]);

  const theme = useTheme();

  useEffect(() => {
    if (
      Array.isArray(hotelDetailResult?.images) &&
      hotelDetailResult.images.length > 0
    ) {
      setHotelImages(hotelDetailResult.images);
    } else {
      setHotelImages([defaultImage]);
    }
  }, [hotelDetailResult]);

  return (
    <Box
      sx={{
        borderRadius: '8px',
        backgroundColor: '#fff',
        mb: '2vh',
        p: { xs: 2, sm: 3 },
      }}
    >
      {/* Header */}
      <HotelHead
        detailsHotel={hotelDetailResult}
        handleShowModal={handleShowModal}
      />

      {/* Main Content */}
      <Grid container spacing={2} alignItems="flex-start">
        {/* Left Column */}
        <Grid item xs={12} md={9}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: 2, sm: 4 },
            }}
          >
            <HotelImageCarousel
              hotelImages={hotelImages}
              defaultImage={defaultImage}
            />
            <HotelDescription descriptionHotel={hotelDetailResult} />
          </Box>
        </Grid>

        {/* Sidebar */}
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              border: '4px solid #E5E5E5',
              borderRadius: '8px',
              p: { xs: 1, sm: 2 },
              width: { xs: '100%', md: '270px' },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <PricesHotelDetail details={hotelDetailResult} search={search} />

            <Button
              onClick={goToTable}
              sx={{
                width: '100%',
                height: '40px',
                mt: 1,
                textTransform: 'none',
                fontSize: '16px',
                fontWeight: 600,
                color: '#fff',
                borderRadius: '8px',
                backgroundColor: '#03C868',
                '&:hover': { backgroundColor: '#02ae5a' },
              }}
            >
              Ver disponibilidad
            </Button>

            <Button
              onClick={handleShowModal}
              sx={{
                width: '100%',
                height: '40px',
                mt: 1,
                textTransform: 'none',
                fontSize: '16px',
                fontWeight: 600,
                color: theme?.tertiary,
                backgroundColor: '#fff',
                border: `1px solid ${theme?.tertiary}`,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                '&:hover': { backgroundColor: '#f6e6e6' },
              }}
            >
              <RoomIcon fontSize="small" />
              Ver en mapa
            </Button>

            <Button
              variant="outlined"
              onClick={handleOpenShareModal}
              sx={{
                width: '100%',
                mt: 1,
                height: '40px',
                fontSize: '16px',
                fontWeight: 600,
                color: theme?.tertiary,
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                '&:hover': { background: 'none' },
              }}
            >
              <ShareIcon sx={{ mr: 1 }} />
              Compartir
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BoxHotelDetails;
